import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from "highcharts/highcharts-more";
@Component({
  selector: 'app-edit-card-graph',
  templateUrl: './edit-card-graph.component.html',
  styleUrls: ['./edit-card-graph.component.scss']
})
export class EditCardGraphComponent implements OnInit {

  constructor() { }
  @Input() guageValue: any;
  @Input() index: any;
  @Input() kpiScore: any;
  @Input() xaxis: any;
  @Input() yaxis: any;
  @Input() arrangedXvalues:any;
  ngOnInit() {
  }
  public array: Array<any> = [];
  ngAfterViewInit() {
    this.assignToGraph();
  }

  assignToGraph() {
    let kpivalue = [];
    let kpilabel = [];
    if (this.guageValue && this.guageValue.length > 0) {
      if(this.arrangedXvalues){
     let dataArray = [];
      for(let i=0;i<this.arrangedXvalues.length;i++){
        for(let j =0;j<this.guageValue.length;j++ ){
            if(this.arrangedXvalues[i]==this.guageValue[j]['name']){
              dataArray.push(this.guageValue[j]);
              break;
            }
        }
      }
      this.guageValue=[];
      this.guageValue = [...dataArray];
    }
      for (let i = 0; i < this.guageValue.length; i++) {
        if (this.guageValue[i]['value'])
          kpivalue.push(+(this.guageValue[i]['value'].toFixed(2)));
        if (this.guageValue[i]['kpiValue'])
          kpivalue.push(+(this.guageValue[i]['kpiValue'].toFixed(2)));
        if (this.guageValue[i]['name'])
          kpilabel.push(this.guageValue[i]['name']);
      }
    }
    let Max_number = Math.ceil(Math.max(...kpivalue));
    let inter = setInterval(() => {
      let element: any = document.getElementById("bar-edit" + this.index);
      if (element) {
        clearInterval(inter);

        Highcharts.chart(element, {
          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            categories: kpilabel,
            labels: {
              enabled: true,
              rotation: 0,
              formatter: function ():any {
                  let str:any= this.value.toString();
                  if(kpilabel.length>3){
                  return '<span style="color:#666666;" title="' + this.value + '">' + str.substr(0,3)+'..'+ '</span>';
  
                            }else{
          return '<span style="color:#666666;" title="' + this.value + '">' + str+ '</span>';
  
                            }
                                        },
  useHTML: true,
  },
            min: 0,
            title: {
              text: this.xaxis?null: this.kpiScore + '-score(Breakup)',
            },
          },
          yAxis: {
            allowDecimals: false,
            min: 0,
            max:Max_number,
            title: {
              text:this.yaxis?null: this.kpiScore + '(Score)',
            },
          },

          plotOptions: {
            column: {
               pointPadding: 0,
            borderRadius: 5,
            borderWidth: 2,
            groupPadding:0.15,
            shadow: false,
            dataLabels: {
              enabled: true,
              overflow: 'allow',
              crop: false,
              formatter: function() {
                return this.y > 0 ? this.y : null;
            },
              align:'center',
              color: 'black',
              inside:false,
            },
            }
          },
          series: [{
            name:'kpi-score',
            data: kpivalue,
            showInLegend:false,
            type: undefined
          }]
        });
      }
    }, 100);

  }
}